import React from 'react';
import ModuleBase from '../../components/ModuleBase/ModuleBase';
import styles from './style.module.scss';

const RichText = ({ data, onEdit }) => {
    const { content, style = {} } = data || {};

    return (
        <ModuleBase onEdit={onEdit} style={style}>
            <div className={styles.richText}>
                <div 
                    className={styles.content}
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            </div>
        </ModuleBase>
    );
};

export default RichText;